import { useState } from 'react'

import { useTimeZone } from '../../../hooks'
import { AppointmentFollowUpModal } from '../../Appointment'
import { Container } from '../Container'

import { APPOINTMENT_FOLLOW_UPS_FIXTURES } from './AppointmentFollowUps.constants'
import { getAppointmentFollowUpsFixture } from './AppointmentFollowUps.mock'
import { AppointmentFollowUpsButton } from './AppointmentFollowUpsButton'

function AppointmentFollowUps() {
  const timezone = useTimeZone()

  const [appointment, setAppointment] = useState(null)

  function handleOpen(fixture) {
    getAppointmentFollowUpsFixture({ fixture, timezone }).then(setAppointment)
  }

  function handleClose() {
    setAppointment(null)
  }

  return (
    <Container label='Follow-up prompt on the mock client'>
      {APPOINTMENT_FOLLOW_UPS_FIXTURES.map(fixture => (
        <AppointmentFollowUpsButton
          fixture={fixture}
          key={fixture.id}
          onOpen={handleOpen}
        />
      ))}
      {appointment ? (
        <AppointmentFollowUpModal
          appointment={appointment}
          onClose={handleClose}
        />
      ) : null}
    </Container>
  )
}

export default AppointmentFollowUps
